import React from 'react';
import { Check, Lock, ShieldCheck, Zap } from 'lucide-react';
export function Offer() {
  return <section className="py-8 bg-gradient-to-b from-navy to-[#4A2B2B]" data-id="element-85">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-86">
        <h2 className="text-4xl md:text-5xl font-heading font-bold text-offwhite mb-8" data-id="element-87">
          Esto es para ti:
        </h2>

        <div className="bg-cream rounded-[24px] p-8 md:p-12 shadow-2xl text-left max-w-2xl mx-auto" data-id="element-88">
          {/* Product Image with "Formato Digital" badge */}
          <div className="relative mb-8 rounded-2xl overflow-hidden shadow-lg" data-id="element-89">
            <img src="https://cdn.magicpatterns.com/uploads/7kMHMDajP8CCj8z5LVNUqY/54c42c34-728e-4842-a119-181bff2318e4.png" alt="Neuro-Control Mental - Protocolo completo" className="w-full h-auto object-cover" data-id="element-90" />
            <div className="absolute top-4 right-4 bg-navy text-offwhite text-xs font-bold px-3 py-1.5 rounded-lg shadow-lg border border-yellow/30" data-id="element-91">
              📱 Formato Digital
            </div>
          </div>

          <ul className="space-y-6 mb-8" data-id="element-92">
            <li className="flex items-start" data-id="element-93">
              <div className="mt-1 bg-emerald-100 p-1.5 rounded-full mr-4 flex-shrink-0" data-id="element-94">
                <Check className="w-5 h-5 text-emerald-600" data-id="element-95" />
              </div>
              <div className="flex-1 border-b border-charcoal/10 pb-5" data-id="element-96">
                <div className="flex justify-between items-start mb-1" data-id="element-97">
                  <span className="text-lg font-bold text-charcoal leading-tight" data-id="element-98">
                    Protocolo para estimular el Nervio Vago (Acción en 120
                    segundos)
                  </span>
                  <span className="text-charcoal/50 line-through text-sm whitespace-nowrap ml-4" data-id="element-99">
                    $997 MXN
                  </span>
                </div>
                <p className="text-sm text-charcoal/70 leading-relaxed" data-id="element-100">
                  La técnica principal para resetear tu sistema nervioso y
                  apagar la respuesta de pánico al instante.
                </p>
              </div>
            </li>
            <li className="flex items-start" data-id="element-101">
              <div className="mt-1 bg-emerald-100 p-1.5 rounded-full mr-4 flex-shrink-0" data-id="element-102">
                <Check className="w-5 h-5 text-emerald-600" data-id="element-103" />
              </div>
              <div className="flex-1 border-b border-charcoal/10 pb-5 text-center" data-id="element-104">
                <div className="mb-2" data-id="element-105">
                  <span className="inline-block bg-emerald-500 text-white text-sm font-bold px-4 py-1.5 rounded-full uppercase tracking-wider animate-pulse shadow-md shadow-emerald-500/30" data-id="element-106">
                    🎁 BONO GRATIS
                  </span>
                </div>
                <div className="flex justify-between items-start mb-1" data-id="element-107">
                  <span className="text-lg font-bold text-charcoal leading-tight flex-1 text-center" data-id="element-108">
                    Guía para frenar el sobrepensamiento
                  </span>
                  <span className="text-charcoal/50 line-through text-sm whitespace-nowrap ml-4" data-id="element-109">
                    $497 MXN
                  </span>
                </div>
                <p className="text-sm text-charcoal/70 leading-relaxed" data-id="element-110">
                  Aprende a detener el "replay mental" después de interactuar
                  con otros y recupera tu paz mental.
                </p>
              </div>
            </li>
            <li className="flex items-start" data-id="element-111">
              <div className="mt-1 bg-emerald-100 p-1.5 rounded-full mr-4 flex-shrink-0" data-id="element-112">
                <Check className="w-5 h-5 text-emerald-600" data-id="element-113" />
              </div>
              <div className="flex-1 pb-2 text-center" data-id="element-114">
                <div className="mb-2" data-id="element-115">
                  <span className="inline-block bg-emerald-500 text-white text-sm font-bold px-4 py-1.5 rounded-full uppercase tracking-wider animate-pulse shadow-md shadow-emerald-500/30" data-id="element-116">
                    🎁 BONO GRATIS
                  </span>
                </div>
                <div className="flex justify-between items-start mb-1" data-id="element-117">
                  <span className="text-lg font-bold text-charcoal leading-tight flex-1 text-center" data-id="element-118">
                    El Arte de la Presencia Calma: Guía de fluidez para
                    situaciones de alta exposición
                  </span>
                  <span className="text-charcoal/50 line-through text-sm whitespace-nowrap ml-4" data-id="element-119">
                    $297 MXN
                  </span>
                </div>
                <p className="text-sm text-charcoal/70 leading-relaxed" data-id="element-120">
                  Cómo preparar tu mente para evitar sentir pánico y
                  autoboicotearte. Ideal para antes de una exposición o una cita
                  con alguien.
                </p>
              </div>
            </li>
          </ul>

          <div className="text-center mb-8" data-id="element-121">
            <p className="text-charcoal/50 font-medium mb-2" data-id="element-122">
              Valor Total: <span className="line-through" data-id="element-123">$1,791 MXN</span>
            </p>
            <p className="text-5xl font-heading font-bold text-red-600" data-id="element-124">
              HOY: $140 MXN
            </p>
          </div>

          <a href="https://pay.hotmart.com/P104890681K?checkoutMode=10" target="_blank" rel="noopener noreferrer" className="block w-full bg-red-600 hover:bg-red-700 text-white font-heading font-bold text-xl py-6 px-8 rounded-full shadow-xl animate-heartbeat mb-6 text-center" data-id="element-125">
            QUIERO LA SOLUCIÓN DE RAÍZ — $140 MXN →
          </a>

          <div className="text-center mb-8 bg-yellow/20 border border-yellow/50 rounded-xl py-3 px-4" data-id="element-126">
            <p className="text-base font-bold text-charcoal" data-id="element-127">
              Pago único. Sin suscripciones. Acceso inmediato desde tu celular.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-128">
            <div className="border-2 border-charcoal/15 rounded-xl p-4 text-center bg-white" data-id="element-129">
              <Lock className="w-8 h-8 text-sage mx-auto mb-2" data-id="element-130" />
              <h4 className="font-bold text-charcoal text-sm" data-id="element-131">
                Pago 100% Seguro
              </h4>
              <p className="text-xs text-charcoal/60 mt-1" data-id="element-132">
                Cifrado SSL de grado bancario
              </p>
            </div>
            <div className="border-2 border-charcoal/15 rounded-xl p-4 text-center bg-white" data-id="element-133">
              <ShieldCheck className="w-8 h-8 text-sage mx-auto mb-2" data-id="element-134" />
              <h4 className="font-bold text-charcoal text-sm" data-id="element-135">
                Garantía de 7 Días
              </h4>
              <p className="text-xs text-charcoal/60 mt-1" data-id="element-136">
                Te devolvemos cada peso si no funciona
              </p>
            </div>
            <div className="border-2 border-charcoal/15 rounded-xl p-4 text-center bg-white" data-id="element-137">
              <Zap className="w-8 h-8 text-sage mx-auto mb-2" data-id="element-138" />
              <h4 className="font-bold text-charcoal text-sm" data-id="element-139">
                Acceso Inmediato
              </h4>
              <p className="text-xs text-charcoal/60 mt-1" data-id="element-140">
                Empieza en menos de 2 minutos
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}